module.exports = __webpack_public_path__ + "img/chinaEurope01.990bf159.png";